import { render, staticRenderFns } from "./evaluationConfig.vue?vue&type=template&id=44c7b446&scoped=true&"
import script from "./evaluationConfig.vue?vue&type=script&lang=js&"
export * from "./evaluationConfig.vue?vue&type=script&lang=js&"
import style0 from "./evaluationConfig.vue?vue&type=style&index=0&id=44c7b446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c7b446",
  null
  
)

component.options.__file = "evaluationConfig.vue"
export default component.exports